/** Find a homepage section by id. Hash-prefixed ids are a legacy fallback. */
export function findHomepageSection(sectionId: string): HTMLElement | null {
  if (typeof document === "undefined") return null;
  return (
    document.getElementById(sectionId) ??
    document.getElementById(`#${sectionId}`)
  );
}

export function scrollToHomepageSection(sectionId: string): boolean {
  const section = findHomepageSection(sectionId);
  if (!section) return false;
  section.scrollIntoView({ behavior: "smooth" });
  return true;
}
